// extracted by mini-css-extract-plugin
export default {"collapse":"Widget_collapse__RNQkB"};